import React, { useState, useCallback, useEffect, useMemo } from "react";

// recoil
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userCredentials } from "recoilState/GlobalState";

// utils
import { useFormik } from "formik";
import { Buttons, HeaderButton } from "components";
import { DeleteOutline, Add, Cached } from "@mui/icons-material";
//import Filters from "components/Filters";
import { hotelAdmins as titles } from "consts/titulos-de-tablas";

// styles
import s from "styles/pages/Pages.module.scss";
import { ACTIONS } from "consts/Actions";
import Modal from "components/UI/Modal/Modal";
import XGrid from "components/UI/Grid/XGrid";
import { useService } from "components/route/ServiceRoute";
import { snackbarData } from "recoilState/GlobalState";
import axiosPost from "services/services-mia/axiosPost";
import { DeleteModal, InsertModal, UpdateModal } from "./Actions";
import { connectionRolGet/* , rolGet */ } from "services/services-mia";

export default function HotelAdminsDetail({ hotel }) {
  const [modalDetails, setModalDetails] = useState({ isOpen: false });
  const [isLoading, setIsLoading] = useState(false);
  const [rowSelected, setRowSelected] = useState({ status: false, row: {} });
  const [rows, setRows] = useState([]);
  const [connectionRoles, setConnectionRoles] = useState([]);
  const credentials = useRecoilValue(userCredentials);
  const setSnackbarInfo = useSetRecoilState(snackbarData);

  const { service } = useService();

  const updateList = useCallback(async () => {
    setRowSelected({ status: false, row: {} });
    setIsLoading(true);
    setRows([]);

    const body = {
      service: "SFHotelEmpleadoGet",
      params: {
        SFHotelId: hotel?.SFHotelId,
      },
    };

    try {
      const { result } = await axiosPost(body, credentials);

      setRows(result.map((item) => {
        const {
          msuAdicionalId,
          msuId,
          SFHotelId,
          rolId,
          rolCod,
          rolNombre,
          usuarioNroDeDocumentoX,
          usuarioApellidos,
          usuarioNombres,
          usuarioFechaDeNacimiento,
          usuarioSexo,
          tipoDeDocumentoCod,
          msuAdicionalVersion
        } = item;

        return {
          id: msuAdicionalId,
          msuId,
          SFHotelId,
          rolId,
          rolCod,
          rolNombre,
          usuarioNroDeDocumentoX,
          usuarioApellidos,
          usuarioNombres,
          usuarioFechaDeNacimiento,
          usuarioSexo,
          tipoDeDocumentoCod,
          msuAdicionalVersion,
          [titles[0].field]: usuarioNombres,
          [titles[1].field]: usuarioApellidos,
          [titles[2].field]: tipoDeDocumentoCod,
          [titles[3].field]: usuarioNroDeDocumentoX ? Number(usuarioNroDeDocumentoX).toLocaleString("es-AR") : "-",
          [titles[4].field]: usuarioSexo,
          [titles[5].field]: usuarioFechaDeNacimiento ? new Date(usuarioFechaDeNacimiento).toLocaleDateString("es-ES", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }) : "-",
          [titles[6].field]: rolNombre
        }
      }));
    } catch (error) {
      console.error("Error al obtener los hoteles:", error);
      setSnackbarInfo({
        open: true,
        severity: "error",
        message: error?.message || "Error al obtener los hoteles",
      });

    } finally {
      setIsLoading(false);
      closeModal();
    }

  }, [credentials, setSnackbarInfo, hotel]);

  const formik = useFormik({
    initialValues: {
      nombre: "",
      estado: "",
    },
    onSubmit: () => {
      updateList(formik.values);
    },
  });

  const handleClick = ({ procede, title }) => {
    setModalDetails({ title, procede, isOpen: true });
  };

  const closeModal = () => {
    setModalDetails({ isOpen: false });
  };

  useEffect(() => {
    updateList();
  }, [updateList]);

  useEffect(() => {
    if (Object.keys(credentials).length > 0 && service?.servicioCod) {
      (async () => {
        const connectionRoles = await connectionRolGet(service.servicioCod, credentials)
        setConnectionRoles(connectionRoles.result);
      })();
    }
  }, [credentials, service])

  const admins = useMemo(() => {
    return rows.filter((r) => r.rolCod === "ADH")
  }, [rows]);

  return (
    <main className={s.main}>
      <Modal onClose={closeModal} open={modalDetails.isOpen} title={modalDetails.title}>
        {modalDetails.procede === ACTIONS.INSERT && (
          <InsertModal
            servicio={service}
            hotelId={hotel?.SFHotelId}
            roles={connectionRoles}
            updateList={updateList}
            closeModal={closeModal}
          />
        )}
        {modalDetails.procede === ACTIONS.DELETE && (
          <DeleteModal
            updateList={updateList}
            closeModal={closeModal}
            employee={rowSelected.row}
          />
        )}
      </Modal>
      <div className={s["filters-actions"]} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>

        <Buttons>
          <HeaderButton
            text={"Actualizar"}
            onClick={updateList}
          >
            <Cached />
          </HeaderButton>
          <HeaderButton
            text={"Agregar admin "}
            handleClick={handleClick}
            data={{
              title: "Agregar admin",
              procede: ACTIONS.INSERT
            }}
            disabled={admins.length > 0}
          >
            <Add />
          </HeaderButton>

          <HeaderButton
            text={"Eliminar Admin"}
            disabled={!rowSelected.row.id || rowSelected.row?.rolCod !== 'ADH'}
            handleClick={handleClick}
            data={{
              title: "Eliminar Admin",
              procede: ACTIONS.DELETE
            }}
          >
            <DeleteOutline />
          </HeaderButton>
        </Buttons>
      </div>
      <div className={s.container}>
        <XGrid
          rows={rows}
          titles={titles}
          loading={isLoading}
          secondarySelected={rowSelected}
          setSecondarySelected={setRowSelected}
        />
      </div>
    </main>
  );
}
